<!-- Team -->
<section id="team">
    <!-- Section Content -->
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="team-horizontal">
                <!-- Team Members एकनिष्ठ व प्रामाणिक -->
                <div class="title-big line-bottom left">बँकेचा अधिकारी वर्ग</div>
                <div class="space"></div>
                <div class="row">
                    <div class="col-md-3 col-sm-12" *ngFor="let i of data">
                        <div class="team">
                            <div class="team-pic">
                                <a href="team-detail.html "><img src="https://nmpksbank.in/apis/{{i.nmpk_staffPhoto}} " alt="{{i.nmpk_staffName}}" height="270" width="100%" class="img-full"></a>
                            </div>
                            <div class="team-detail ">
                                <div class="detail-social ">
                                    <ul class="social-icons nav-default inline clearfix ">
                                        <li><a href="# " class="facebook "><i class="fa fa-facebook "></i></a></li>
                                        <li><a href="# " class="twitter "><i class="fa fa-twitter "></i></a></li>
                                        <li><a href="# " class="google "><i class="fa fa-google-plus "></i></a></li>
                                        <li><a href="# " class="linkedin "><i class="fa fa-linkedin "></i></a></li>
                                    </ul>
                                </div>
                                <div class="detail-name text-bold "><a>{{i.nmpk_staffName}} </a></div>
                                <div class="detail-title ">{{i.nmpk_staffPost}}</div>
                                <div class="detail-title ">{{i.nmpk_staffBranch}}</div>
                            </div>
                        </div>
                        <div class="space "></div>
                    </div>
                </div>
                <div class="padding-v15"></div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>
<!-- Team End -->